export default {"src":"/_next/static/media/company1.5a682a43.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};